<template>
 
    <v-layout row wrap>

      <v-flex :class="leftNav ? 'px-3 sm12 xs12 md3 lg3' : 'px-3 sm12 xs12 md3 lg3'"  v-bind:key="index" v-for="(app, index) in apps">
        <v-card  class="elevation-0 mb-3 border-grey radius-0 in-column account-list">
          <div class="c-layout">
            <div class="cl-flex12 bg-grey v-center">
              <div class="application-img-wrap">
                <img v-if="app.image_url" :src="app.image_url" class="account-logo"/>
                <img v-else src="../../../../assets/images/uno-logo.png" class="account-logo"/>
              </div>
            </div>

            <div class="cl-flex12">
              <div class="application-action-detail py-3 px-2">
                <div class="c-layout">
                   <div  class="cl-flex6">
                        <h2 class="text-left subtitle-1 mt-2 font-weight-bold relative">{{ app.display_name }}</h2>
                      </div>
                      <div  class="cl-flex6 text-right">
                        <a href="#" @click.prevent="showDetail(app)">
                          <v-btn
                            color="primary"
                            depressed
                            d-inline-flex
                            fab
                            small
                            class="mr-2"
                          >
                            <v-icon dark>fa fa-info</v-icon>
                          </v-btn>
                        </a>
                        <a v-if="app.appDetail" :class="app.appDetail.web_link != 'http://localhost' ? '' : 'disable-event'" :href="app.appDetail.web_link + '?token='+ authToken" target="_blank">
                          <v-btn
                            :disabled="app.appDetail.web_link != 'http://localhost' ? false : true"
                            color="primary"
                            depressed
                            d-inline-flex
                            fab
                            small
                          >
                            <v-icon dark>fas fa-long-arrow-alt-right</v-icon>
                          </v-btn>
                        </a>
                      </div>
                  </div>
              </div>
            </div>
  
           
          </div>
        </v-card>
      </v-flex>
      <v-flex sm12 md12 v-if="apps.length < 1">
        <p class="text-xs-center">Your business does not have access to any apps yet.</p>
      </v-flex>
    </v-layout>

</template>
<script>
import Env from '@/env';
import store from '@/store/store';
import AuthApi from '@/components/Controllers/AuthApis';
import Helper from '@/components/Controllers/Helpers';
import { mapGeters, mapActions, mapGetters } from 'vuex';

export default {
  data() {
    return {

    };
  },
  computed: {

    authToken() {
      return this.$store.getters.getLoggedInUserToken;
    },
    ...mapGetters({
      apps: 'application/list',
      selectedLocationAppsList: 'location/apps',
      selectedLocation: 'location/selected',
      leftNav: 'navigation/leftNavStatus',
    }),
  },
  created() {
    this.fetchApps();
  },
  methods: {
    /**
     * All apps 
     */ 
    fetchApps() {
      const url = `${Env.url}/api/v1/businesses/${this.$store.getters.getLoggedInUserSelectedBusinessId}/apps`;
      AuthApi.getApi(url)
        .then((res) => {
          this.setList(res.data.payload);
        })
        .catch(() => {
          console.log('error getting applications')
        });
    },

    /**
     * Show app details
     */
    showDetail(obj) {
      this.setDetail(true);
      this.setDetailObj(obj);
    },
   
    ...mapActions({
     
      setList: 'application/setList',
      setLocationList: 'location/setList',
      setDetail: 'application/setDetail',
      setDetailObj: 'application/setDetailObj',
    }),

  },
};
</script>


